import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import {
  IBriefInfluencerV2,
  INegotiateCost,
} from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useNegotiateBrandCost(
  briefId: string,
  updateBriefInfluencer?: (id: string, data: IBriefInfluencerV2) => void
) {
  const {
    mutate: negotiate,
    isLoading: isNegotiating,
    isSuccess: isNegotiated,
  } = useMutation({
    mutationFn: (data: INegotiateCost) =>
      BriefService.negotiateCost(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, data) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
      updateBriefInfluencer?.(data.data._id, data.data);
    },
  });

  return {
    negotiate,
    isNegotiating,
    isNegotiated,
  };
}
